import React from 'react';
import _ from 'lodash';
import Select from '../../../../../core/web/js/form/Select';
import backgrounds from '../../../json/backgrounds';

/**
 *
 */
function BackgroundSelect(props){
  const backgroundOptions = backgrounds.map(data=>{
    return {
      "value":data.type,
      "label":data.type
    };
  });

  return (
    <Select
      label="Background"
      value={props.state.background}
      options={backgroundOptions}
      change={_changeBackground.bind(this, props)}
    />
  );
}

/**
 *
 */
function _changeBackground(props, e){
  const value = e.target.value;
  let state = _.cloneDeep(props.state);
  state.background = value;
  state.statChoices = {};

  //set default stats
  state.move = props.stats.move;
  state.fight = props.stats.fight;
  state.shoot = props.stats.shoot;
  state.armor = props.stats.armor;
  state.will = props.stats.will;
  state.health = props.stats.health;

  //set default bonuses
  const selectedBackground = backgrounds.filter(data=>{
    return data.type===value;
  })[0];

  const modKeys = Object.keys(selectedBackground.statModifications);
  modKeys.forEach(statName=>{
    const stat = selectedBackground.statModifications[statName];
    state[statName] +=  stat;
  })

  props.updateState(props.stateName, state);
}

export default BackgroundSelect;
